import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { updateAboutMe } from '../../../../redux/actions/profile/aboutMeAction';
import { Card, Typography, Button, Modal, Input, Space, Form, message } from 'antd';
import { EditFilled } from '@ant-design/icons';
import Cookie from "js-cookie";
import CButton from '../../../../components/Button';

const { Text } = Typography;
const { TextArea } = Input;

export class AboutMe extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props)
  
    this.state = {
      submitLoading: false,
      visible: false
    }
  }
  
  showModal = () => {
    this.setState({
      visible: true
    })
  };

  handleCancel = () => {
    this.setState({
      visible: false
    })
  };

  onFinish = async (values) => {
    const { actionUpdateAboutMe, actionGetProfile } = this.props
    
    return this.setState({ submitLoading: true }, () => {
      return actionUpdateAboutMe(values, response => {
        if(response.code === '1000'){
          return this.setState({ submitLoading: false, visible: false }, () => {
            message.success(response.message)
            Cookie.set("activeElement", window.pageYOffset)
            return actionGetProfile()
          })
        }else{
          message.error(response.message)
        }
      }, (err) => {
        return this.setState({ submitLoading: false, visible: false }, () => message.error(err.message))
      })
    })
  }

  render() {
    const { visible, submitLoading } = this.state
    const { t, data } = this.props

    return (
      <React.Fragment>
        <Card 
          className="border-radius-6 box-shadow" 
          title={t('profile.aboutMe.title')} 
          bordered={false} 
          extra={<Button type="link" icon={<EditFilled />} onClick={this.showModal}>Edit</Button>} 
          headStyle={{ color: '#32ab6d', fontSize: 17 }}
          bodyStyle={ data.about ? {} : { textAlign: 'center', padding: 60 } }
        >
          {
            data.about ?
              <Text type="secondary">{data.about}</Text>
            :
              <Text className="dark-color">{t('profile.aboutMe.textCard')}</Text>
          }
        </Card>

        <Modal 
          title= {
            <Space align='middle' size={1}>
              {`${t('profile.aboutMe.title') }`} 
              <Text type='danger'>*</Text>
            </Space>
          }
          visible={visible} 
          onCancel={this.handleCancel} 
          footer={false}
          bodyStyle={{ paddingBottom: 4 }}
          centered
          width={600}
          destroyOnClose
          maskClosable={false}
        >
          <Form 
            ref={this.formRef}
            onFinish={this.onFinish}
            initialValues={{
              about: data.about
            }}
          >
            <Form.Item 
              name="about"
              rules={[
                { required: true, message: t('required') },
                { max: 1000, message: t('max',{number:1000}) }
              ]}
            >
              <TextArea rows={3} />
            </Form.Item>
            <Form.Item>
              <Space className="float-right">
                {/* <Button onClick={this.handleCancel}>{t('profile.buttonBack')}</Button>
                <Button htmlType="submit" type="primary" loading={submitLoading}>{t('profile.buttonSave')}</Button> */}
                  <CButton type='default' title={t('profile.buttonBack')} action={this.handleCancel}/>
                  <CButton type="primary" title={t('profile.buttonSave')} htmlType="submit" loading={submitLoading} />
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
    
})

const mapDispatchToProps = {
  actionUpdateAboutMe: updateAboutMe
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AboutMe))